import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.common.white,
				position: "relative",
				marginBottom: 10,
				borderRadius: 6,
				zIndex: 4,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)"
			},
			borderProduct: {
				borderRadius: 6,
				display: "flex",
				zIndex: 2
			},
			img: {
				display: "flex",
				alignItems: "center",
				background: theme.palette.common.white,
				padding: 10,
				zIndex: 2,
				borderRadius: 6,
				"& > img": {
					objectFit: "contain"
				}
			},
			body: {
				width: "100%",
				padding: "10px 10px 10px 0px"
			},
			nameProduct: {
				fontSize: 12,
				fontWeight: 500,
				color: theme.palette.primary.contrastText
			},
			bodyInfoProduct: {
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center"
			},
			mt10: {
				marginTop: 15
			},
			cartType: {
				width: "100%",
				fontSize: 12,
				color: theme.palette.info.light
			},
			priceCart: {
				fontWeight: 500,
				color: theme.palette.primary.contrastText,
				fontSize: 12
			}
		}),
	{
		name: "ProductItem",
		index: 1
	}
);

export default useStyles;
